<template>
    <div :ref="stepName" style="position:relative">
        <IbanForm></IbanForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import IbanForm from "./IbanForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { IbanForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
